/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ─── Styles ───────────────────────────────────────────────────────────────
  var _style = document.createElement('style');
  _style.textContent = [
    /* Stars */
    '.product-item__stars-row{display:flex;align-items:center;gap:2px;margin:4px 0 6px;flex-wrap:nowrap}',
    '.product-item__stars-row .star{font-size:14px;line-height:1;color:#d8d8d8}',
    '.product-item__stars-row .star--full{color:#f5a623}',
    '.product-item__review-count{font-size:11px;color:var(--text-light,#888);margin-left:3px;white-space:nowrap}',
    /* ATC button */
    '.product-item__atc-wrap{padding:8px var(--inner,12px) 4px}',
    '.product-item__atc-btn{display:block!important;width:100%!important;text-align:center;',
    'font-size:12px;padding:9px 12px;cursor:pointer;border:none;letter-spacing:.05em;',
    'transition:opacity .2s}',
    '.product-item__atc-btn:disabled{opacity:.55;cursor:not-allowed}',
    '.product-item__atc-wrap .quick-add__holder{padding:0}'
  ].join('');
  document.head.appendChild(_style);


  // ─── FIX: Deduplicate concurrent /cart/add network requests ───────────────
  //
  // Root cause: Broadcast's CartDrawer and the Corner Cart app both independently
  // call fetch('/cart/add') when the ATC button is clicked. Each adds qty=1,
  // so the cart ends up with qty=2 for the product the user added.
  //
  // Solution: intercept window.fetch. Allow the FIRST /cart/add call through.
  // Any duplicate call within 1.5s returns a synthetic response with the same
  // JSON data — so both Broadcast and Corner see "success" without a second
  // real add being sent to Shopify.

  var _origFetch = window.fetch;
  var _cartAddInFlight = null; // Promise<{data, httpStatus}>

  function trackCartAdd(realFetchPromise) {
    _cartAddInFlight = realFetchPromise.then(function(response) {
      return response.clone().json().then(function(data) {
        return { data: data, httpStatus: response.status };
      }).catch(function() {
        return { data: {}, httpStatus: response.status };
      });
    });

    // Clear dedup window after 1.5 s so the next intentional add works normally
    setTimeout(function() { _cartAddInFlight = null; }, 1500);

    return realFetchPromise;
  }

  window.fetch = function(resource, options) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var isCartAdd = /\/cart\/add/.test(url) && options && options.method === 'POST';

    if (isCartAdd) {
      if (_cartAddInFlight) {
        // Duplicate call while another /cart/add is in flight — return cached data
        return _cartAddInFlight.then(function(cached) {
          return new Response(JSON.stringify(cached.data), {
            status: cached.httpStatus,
            headers: new Headers({ 'Content-Type': 'application/json' })
          });
        });
      }

      return trackCartAdd(_origFetch.apply(this, arguments));
    }

    return _origFetch.apply(this, arguments);
  };


  // ─── Inject ATC buttons into product grid cards ───────────────────────────
  //
  // Reason: Shopify CDN caches the rendered HTML, so Liquid template changes
  // may take time to propagate. We inject the buttons client-side immediately
  // on every page load so customers always see them.
  //
  // Works for:
  //   - Single-variant products → "Agregar al carrito" (direct AJAX add)
  //   - Multi-variant products  → "Seleccionar opciones" (opens quick-add modal)

  function injectProductGridATC() {
    // Find all product cards that don't already have a button
    var infoEls = Array.prototype.slice.call(
      document.querySelectorAll('.product-item__info')
    );
    if (!infoEls.length) return;

    var pending = [];
    infoEls.forEach(function(info) {
      // Skip if already has our button (Liquid rendered it or we already injected)
      if (info.querySelector('.product-item__atc-wrap')) return;

      var link = info.querySelector('a.product-link');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      var m = href.match(/\/products\/([^?#\/]+)/);
      if (!m) return;

      pending.push({ info: info, handle: m[1], href: href });
    });

    if (!pending.length) return;

    // Fetch all product JSONs in parallel
    var promises = pending.map(function(item) {
      return _origFetch('/products/' + item.handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) { item.product = p; return item; })
        .catch(function() { return item; });
    });

    Promise.all(promises).then(function(items) {
      items.forEach(function(item) {
        var p = item.product;
        if (!p || !p.available) return;

        // Find first available variant
        var variant = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) { variant = p.variants[i]; break; }
        }
        if (!variant) return;

        var wrap = document.createElement('div');
        wrap.className = 'product-item__atc-wrap';

        if (p.variants.length === 1) {
          // ── Single variant: direct add-to-cart ──────────────────────────
          wrap.innerHTML =
            '<button type="button" ' +
            '  class="btn btn--primary btn--solid product-item__atc-btn" ' +
            '  data-product-atc ' +
            '  data-vid="' + variant.id + '">' +
            '  <span class="btn__text">Agregar al carrito</span>' +
            '</button>';
        } else {
          // ── Multi-variant: open quick-add modal ─────────────────────────
          wrap.innerHTML =
            '<quick-add-product>' +
            '  <div class="quick-add__holder" data-quick-add-holder="' + p.id + '">' +
            '    <button type="button" ' +
            '      class="btn btn--primary btn--solid product-item__atc-btn" ' +
            '      data-quick-add-btn ' +
            '      data-quick-add-modal-handle="' + p.handle + '">' +
            '      <span class="btn__text">Seleccionar opciones</span>' +
            '    </button>' +
            '  </div>' +
            '</quick-add-product>';
        }

        item.info.appendChild(wrap);
      });
    });
  }

  // ── Handle direct ATC clicks (single-variant) ────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-product-atc]');
    if (!btn) return;
    e.preventDefault();

    var vid = btn.getAttribute('data-vid');
    var btnText = btn.querySelector('.btn__text');
    if (!vid) return;

    btn.disabled = true;
    if (btnText) btnText.textContent = 'Agregando…';

    fetch('/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(vid), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (btnText) btnText.textContent = '✓ Agregado';
      // Notify Broadcast / Corner Cart that cart changed
      document.dispatchEvent(new CustomEvent('theme:cart:add', {
        bubbles: true,
        detail: { element: btn }
      }));
      setTimeout(function() {
        btn.disabled = false;
        if (btnText) btnText.textContent = 'Agregar al carrito';
      }, 2500);
    })
    .catch(function() {
      btn.disabled = false;
      if (btnText) btnText.textContent = 'Error — intenta de nuevo';
      setTimeout(function() {
        if (btnText) btnText.textContent = 'Agregar al carrito';
      }, 2500);
    });
  });

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectProductGridATC);
  } else {
    injectProductGridATC();
  }


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
